module.exports = __webpack_public_path__ + "img/IMG-20190904-WA0001.da36326e.jpg";